export default __webpack_public_path__ + "static/media/user.12d43be2.png";